export default __webpack_public_path__ + "static/cert-7-img-20c9d24ef51c747e7f9eff06a39d71b5.png";